export default __webpack_public_path__ + "static/media/ql_08.477eec3f.png";